import { isEmpty } from '../../../library/Core/SmartFunctions';
import { State } from '../../../library/Core/SmartTypes';
import { axiosClient } from '../../../library/Service/axiosClient';

export const handleInstituteSelection = async (
    institute: any,
    id: string,
    state: any,
    dispatch: any,
    redirectTo: string = ''
) => {
    const response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_SERVER}/v1/auth/internal-user-token/${institute.instituteId}/${id}`, {});
    const tokenForSelectedInstitute = response?.data?.token;

    const navigateToUrl = navigateToLandingPage(response?.data?.selectedInstitute, id, state, dispatch);

    if (navigateToUrl === -1) {

        if(redirectTo && redirectTo.length > 0){
            const redirectUrls = ['office-usage']
            const redirectToValid = redirectUrls.includes(redirectTo);
            window.location.href = redirectToValid ? `/alumni/${id}/profile/${redirectTo}` : `/alumni/${id}/profile`;
            return;
        }
        
        // Get the previous URL from document.referrer
        const previousUrl = document.referrer;
        console.log("previousUrl: ", previousUrl)

        if (previousUrl && previousUrl.length > 0) {
            window.location.href = previousUrl;
        } else {
            // Fallback to one step back if no referrer
            window.history.back();
        }
    } else {
        // window.location.href = navigateToUrl;
    }
    return;
};

const navigateToLandingPage = (institute: any, studentId: string, state: any, dispatch: any) => {
    const { userStatusCode, userTypeCode, instituteTypeCode, profileStatusCode, genderCode, isPeerReviewed, presentEducationStatusCode, pursuingEducationLevelCode, highestCompletedEducationLevelCode } = institute;
    // if ( ! isEmpty(genderCode) && ! isEmpty(presentEducationStatusCode) && ( ! isEmpty(pursuingEducationLevelCode) || ! isEmpty(highestCompletedEducationLevelCode) )) {
    //     localStorage.setItem('selectedInstitute', JSON.stringify(institute));
    //     dispatch({
    //         type: 'REFRESH_DATA',
    //         payload: { data: { ...state.data, selectedInstitute: state.data?.userInstitutes[0] } },
    //     });
    //     return -1;
    // } else {
    //     alert('Please fill the basic info');
    //     return `/alumni/${studentId}/info`;
    // }

    localStorage.setItem('selectedInstitute', JSON.stringify(institute));
    dispatch({
        type: 'REFRESH_DATA',
        payload: { data: { ...state.data, selectedInstitute: state.data?.userInstitutes[0] } },
    });
    return -1;
};
